import { createAsyncThunk } from "@reduxjs/toolkit";
import { getObjectTypes } from "domain/object-types/api/get-object-types";
import { ObjectTypesRequestDto } from "domain/object-types/entities/dtos/object-types-request.dto";

export const getObjectTypesAction = createAsyncThunk(
  "object-types/v2/getObjectTypesAction",
  async ({ accountId }: ObjectTypesRequestDto) => {
    try {
      return await getObjectTypes({ accountId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
